import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { getAuthHeader } from '../../utils';
import { v4_microsoft_mailbox_configure } from '../../actions/v4/mailBox';
import { toast } from 'react-toastify';
import constant from '../../constant';

const MicrosoftAuthCallBack = () => {
    const history = useHistory();   // ✅ correct hook

    const [status, setStatus] = useState('loading');
    const [error, setError] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (!code) {
            setStatus('error');
            setError('Authorization code not found.');
            return;
        }

        exchangeCodeForToken(code);
    }, []);

    const exchangeCodeForToken = async (code) => {
        try {
            setStatus('loading');
            const response = await v4_microsoft_mailbox_configure({ authCode: code, redirect_uri: window.location.origin + '/auth/callback' })
            if (response.status) {
                setStatus('success');
                toast.success(response.result.message)                // ✅ redirect after success
                history.push(constant.Authedcomponent.mailBox.url);
            } else {
                throw new Error(response.data?.message || 'Authentication failed');
            }
        } catch (err) {
            setStatus('error');
            setError(err.response?.data?.message || err.message);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            {status === 'loading' && (
                <div className="text-center">
                    <h5>Signing you in with Microsoft…</h5>
                    <p>Please wait</p>
                </div>
            )}

            {status === 'success' && (
                <div className="text-center text-success">
                    <h5>Microsoft account connected successfully</h5>
                    <p>Redirecting…</p>
                </div>
            )}

            {status === 'error' && (
                <div className="text-center text-danger">
                    <h5>Microsoft Authentication Failed</h5>
                    <p>{error}</p>
                </div>
            )}
        </div>
    );
};

export default MicrosoftAuthCallBack;
